import { isEmpty } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Image, Modal, Row } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import { amApi } from "../../../../api/apiHelper";
import Debounce from "../../../../function/debounce";

const CloneExp = ({ expType, showClone, setShowClone, onClone, ...props }) => {
  const [search, setSearch] = useState("");
  const [expData, setExpData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [selected, setSelected] = useState("");

  async function fetchRecent() {
    let response = await amApi(
      `/experience?expType=${expType}&type=recentList`
    );
    setExpData(response.data);
    setInitialData(response.data);
  }

  const fetchData = async (value) => {
    if (value) {
      let response = await amApi(`/experience?search=${value}&type=${expType}`);
      setExpData(response.data);
    } else {
      fetchRecent();
    }
  };

  const debounceOnChange = useCallback(Debounce(fetchData, 1000), []);
  
  useEffect(() => {
    fetchRecent();
  }, []);

  useEffect(() => {
    if (!search && !expData.length) {
      setExpData(initialData);
    }
  }, [search]);

  return (
    <Modal
      show={showClone}
      onHide={() => setShowClone(false)}
      centered
      className="xl-width-750 selectCatalogueModal"
    >
      <Modal.Header className="px-4 border-0 py-4" closeButton>
        <div className="w-100">
          <Modal.Title className="f20-700 pb-2">
            Search or Select Experience to Copy
          </Modal.Title>
          <div className="d-flex mobileColumn justify-content-between">
            <Form.Control
              type="text"
              placeholder="Search By Experience Id/Experience Name"
              className="amSearch"
              style={{ width: "100%", backgroundColor: "#fff" }}
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debounceOnChange(e.target.value);
              }}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="px-4">
        <div className="enGlobleCatelogueModalListMain">
          <div className="d-flex align-items-center mb-4">
            <div className="d-flex align-items-center justify-content-around w-100">
              <div className="col-3 flexcenter f16-700">Exp. ID</div>
              <div className="col-4 flexcenter f16-700">Experience Name</div>
              <div className="col-3 flexcenter f16-700">Category</div>
              <div className="col-2 flexcenter f16-700">Select</div>
            </div>
          </div>

          <Scrollbars style={{ width: "100%", height: 280 }}>
            {expData?.length ? (
              expData.map((item, index) => (
                <div className="d-flex align-items-center mb-4" key={index}>
                  <div className="d-flex align-items-center justify-content-around w-100">
                    <div className="col-3 flexcenter f14-500 ">
                      ID : # {item.expId}
                    </div>
                    <div className="col-4 flexcenter f14-500 ">{item.name}</div>
                    <div className="col-3 flexcenter f14-500">
                      {item?.category?.title || ""}
                    </div>
                    <div className="col-2 flexcenter">
                      <label className="enRadioWithText small">
                        <input
                          type="radio"
                          name="ItemCode"
                          checked={selected === item._id}
                          onClick={() => setSelected(item._id)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <></>
            )}
          </Scrollbars>
        </div>

        <div className="mobile-center d-flex align-items-center py-4">
          <Button
            variant="outline-secondary"
            className="btn150px btn-lg mr-4 px-5"
            onClick={() => setShowClone(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="btn150px btn-lg px-5"
            onClick={() => onClone(selected)}
          >
            Proceed
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CloneExp;
